import {Component, EventEmitter, Input, Output} from "@angular/core";
import {MatCheckboxChange} from "@angular/material/checkbox";

@Component({
    selector: 'tfl-checkbox',
    template: `
        <mat-checkbox
            [(ngModel)]="checked"
            (change)="itemChecked($event)">
            {{label}}
        </mat-checkbox>
    `
})
export class CheckboxComponent {

    @Input('item') item: any;
    @Input('label') label: string;
    @Input('checked') checked: boolean;
    @Output('itemSelected') itemSelected: EventEmitter<any> = new EventEmitter<any>();
    @Output('itemDeSelected') itemDeSelected: EventEmitter<any> = new EventEmitter<any>();

    private itemChecked(event: MatCheckboxChange) {
        if (event.checked) {
            this.itemSelected.emit(this.item);
            return;
        }
        this.itemDeSelected.emit(this.item)
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/category-checkbox/checkbox.component.ts